/**
 * @flow
 * @relayHash 71ec7922c6cc12a2a732ee0ab5c13ea4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type AvailabilityCheckerContainer_viewer$ref = any;
type EmbedContainer_viewer$ref = any;
type EventCreateContainer_viewer$ref = any;
type EventIndexContainer_viewer$ref = any;
type KioskContainer_viewer$ref = any;
type LeadCaptureContainer_viewer$ref = any;
type LinkContainer_viewer$ref = any;
type TemplateListContainer_viewer$ref = any;
export type ViewerQueryVariables = {||};
export type ViewerQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventIndexContainer_viewer$ref & EventCreateContainer_viewer$ref & LeadCaptureContainer_viewer$ref & LinkContainer_viewer$ref & KioskContainer_viewer$ref & EmbedContainer_viewer$ref & AvailabilityCalendarContainer_viewer$ref & AvailabilityCheckerContainer_viewer$ref & TemplateListContainer_viewer$ref
  |}
|};
export type ViewerQuery = {|
  variables: ViewerQueryVariables,
  response: ViewerQueryResponse,
|};
*/


/*
query ViewerQuery {
  viewer {
    ...EventIndexContainer_viewer
    ...EventCreateContainer_viewer
    ...LeadCaptureContainer_viewer
    ...LinkContainer_viewer
    ...KioskContainer_viewer
    ...EmbedContainer_viewer
    ...AvailabilityCalendarContainer_viewer
    ...AvailabilityCheckerContainer_viewer
    ...TemplateListContainer_viewer
    id
  }
}

fragment EventIndexContainer_viewer on User {
  id
  needs_square_scopes
  ...AvailabilityCheckerContainer_viewer
}

fragment EventCreateContainer_viewer on User {
  id
  past_referral_sources
  s_time_zone
  ...AvailabilityCheckerContainer_viewer
  ...AvailabilityCalendarContainer_viewer
}

fragment LeadCaptureContainer_viewer on User {
  id
  ...AvailabilityCheckerContainer_viewer
}

fragment LinkContainer_viewer on User {
  id
  embed_token
  s_recaptcha_enabled
  s_recaptcha_site_key
  s_recaptcha_secret_key
  phones {
    edges {
      node {
        id
        number
        verified
      }
    }
  }
  s_text_on_embed_submit
  ...AvailabilityCheckerContainer_viewer
}

fragment KioskContainer_viewer on User {
  id
  embed_token
  s_recaptcha_enabled
  s_recaptcha_site_key
  s_recaptcha_secret_key
  ...AvailabilityCheckerContainer_viewer
}

fragment EmbedContainer_viewer on User {
  id
  embed_token
  s_recaptcha_enabled
  s_recaptcha_site_key
  s_recaptcha_secret_key
  s_time_zone
  phones {
    edges {
      node {
        id
        number
        verified
      }
    }
  }
  s_text_on_embed_submit
  ...AvailabilityCheckerContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment TemplateListContainer_viewer on User {
  ...AvailabilityCheckerContainer_viewer
  id
  c_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  form_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  mp_templates {
    edges {
      node {
        id
        title
        can_edit
        public
      }
    }
  }
  public_mp_templates {
    edges {
      node {
        id
        title
        can_edit
        public
      }
    }
  }
  primary_brand {
    id
  }
  features {
    music_lists
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v2 = {
  "kind": "Literal",
  "name": "return_empty_connection",
  "value": true,
  "type": "Boolean"
},
v3 = {
  "kind": "Literal",
  "name": "visibility",
  "value": [
    "SHOW"
  ],
  "type": "[UserEventVisibility]"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = [
  v0,
  v4
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEvent",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": v5
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          },
          v6,
          v7,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [
              v1
            ],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [
                      v4,
                      v6,
                      v7,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "all_day",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "location",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "room",
                        "args": null,
                        "storageKey": null
                      },
                      v0
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
],
v9 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "MpTemplateEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "MpTemplate",
        "plural": false,
        "selections": [
          v0,
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "public",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ViewerQuery",
  "id": null,
  "text": "query ViewerQuery {\n  viewer {\n    ...EventIndexContainer_viewer\n    ...EventCreateContainer_viewer\n    ...LeadCaptureContainer_viewer\n    ...LinkContainer_viewer\n    ...KioskContainer_viewer\n    ...EmbedContainer_viewer\n    ...AvailabilityCalendarContainer_viewer\n    ...AvailabilityCheckerContainer_viewer\n    ...TemplateListContainer_viewer\n    id\n  }\n}\n\nfragment EventIndexContainer_viewer on User {\n  id\n  needs_square_scopes\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment EventCreateContainer_viewer on User {\n  id\n  past_referral_sources\n  s_time_zone\n  ...AvailabilityCheckerContainer_viewer\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment LeadCaptureContainer_viewer on User {\n  id\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment LinkContainer_viewer on User {\n  id\n  embed_token\n  s_recaptcha_enabled\n  s_recaptcha_site_key\n  s_recaptcha_secret_key\n  phones {\n    edges {\n      node {\n        id\n        number\n        verified\n      }\n    }\n  }\n  s_text_on_embed_submit\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment KioskContainer_viewer on User {\n  id\n  embed_token\n  s_recaptcha_enabled\n  s_recaptcha_site_key\n  s_recaptcha_secret_key\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment EmbedContainer_viewer on User {\n  id\n  embed_token\n  s_recaptcha_enabled\n  s_recaptcha_site_key\n  s_recaptcha_secret_key\n  s_time_zone\n  phones {\n    edges {\n      node {\n        id\n        number\n        verified\n      }\n    }\n  }\n  s_text_on_embed_submit\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TemplateListContainer_viewer on User {\n  ...AvailabilityCheckerContainer_viewer\n  id\n  c_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  form_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  mp_templates {\n    edges {\n      node {\n        id\n        title\n        can_edit\n        public\n      }\n    }\n  }\n  public_mp_templates {\n    edges {\n      node {\n        id\n        title\n        can_edit\n        public\n      }\n    }\n  }\n  primary_brand {\n    id\n  }\n  features {\n    music_lists\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ViewerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventIndexContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "EventCreateContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "LeadCaptureContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "LinkContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "KioskContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "EmbedContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AvailabilityCalendarContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AvailabilityCheckerContainer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "TemplateListContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ViewerQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_recaptcha_secret_key",
            "args": null,
            "storageKey": null
          },
          v0,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              {
                "kind": "Literal",
                "name": "booking_status",
                "value": [
                  "BOOKED",
                  "INITIAL",
                  "CANCELED"
                ],
                "type": "[BookingStatus]"
              },
              v1,
              v2,
              v3
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v8
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCheckerContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              v1,
              v2,
              v3
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v8
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "past_referral_sources",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "embed_token",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_recaptcha_enabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_recaptcha_site_key",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "needs_square_scopes",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "phones",
            "storageKey": null,
            "args": null,
            "concreteType": "PhoneConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PhoneEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Phone",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "number",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "verified",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_text_on_embed_submit",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_templates",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplateConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CTemplate",
                    "plural": false,
                    "selections": v5
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "form_templates",
            "storageKey": null,
            "args": null,
            "concreteType": "FormTemplateConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "FormTemplateEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FormTemplate",
                    "plural": false,
                    "selections": v5
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_templates",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplateConnection",
            "plural": false,
            "selections": v9
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "public_mp_templates",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplateConnection",
            "plural": false,
            "selections": v9
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "primary_brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [
              v0
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "features",
            "storageKey": null,
            "args": null,
            "concreteType": "Features",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "music_lists",
                "args": null,
                "storageKey": null
              },
              v0
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6d7dc36878ca1d3ea9b833c869a9ccee';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/ViewerQuery.graphql.js